import React from 'react';
import PropTypes from 'prop-types';
import safeParse from '../../../../services/safeParse';
import { Col, Row } from 'react-bootstrap';

import Button from '../../../../ui-core/Button/Button';
import LazyImage from '../../../../ui-core/Image';
import SubscriptionSelector from '../../../../components/PaymentModal/SubscriptionSelector';

import {
  LOCAL_STORAGE_CONSTANT,
  TEXT_CONSTANT,
} from '../../../../constants/app';
import { banner, bannerLow, bannerWebp } from '../../images';

import './style.css';
import { useLocation, useParams } from 'react-router';
import { extractJSON } from '../../../../services/jsonUtil';
// import { APP_ROUTES } from '../../../../route';
import { setItem } from '../../../../utils/cache';
// import { Offer } from '../Offer';

export const JoinPlan = props => {
  const { isLoading } = props;
  const params = useParams();
  const location = useLocation();
  const session = extractJSON(LOCAL_STORAGE_CONSTANT.SESSION);

  const handleClick = () => {
    if (props.onClick) {
      if (session) {
        props.onClick(
          TEXT_CONSTANT.START_FREE_TRAIL,
          'isSignup',
          'Join the 30 Day Full Body Mobility Plan on Jen Health!',
        );
      } else {
        if (params.slug) {
          // Set redirectUrl and Slug in local storage
          const urlParams = new URLSearchParams(location.search);
          const page = urlParams.get('page');
          const slug = params.slug || page;
          setItem('redirectToCourse', window.location.href);
          setItem('localMatch', JSON.stringify({ params }));
          setItem('localSlug', slug);
          setItem('isFromCoursePage', Boolean(true));
        }
        // navigate(APP_ROUTES.SIGNUP_ONBOARDING);
        props.onClick(
          TEXT_CONSTANT.START_FREE_TRAIL,
          'isSignup',
          'Join the 30 Day Full Body Mobility Plan on Jen Health!',
        );
      }
    }
  };

  return (
    <Row className="full-body-mobility row-margin-zero">
      <Col
        className="d-flex justify-content-center align-items-center px-4"
        xs={12}
        md={6}
      >
        <div className="full-body-div text-start d-flex flex-column">
          <h2 className="bold">
            Join the{' '}
            <span className="text-white">30 Day Full Body Mobility Plan</span>{' '}
            on Jen Health!
          </h2>
          <p>{safeParse(TEXT_CONSTANT.FULL_BODY_MOBILITY_DESCRIPTION)}</p>
          {/* <Offer coupon="MOBILITY" mode="light" /> */}
          <SubscriptionSelector lightTheme={true} />
          <Button
            onClick={handleClick}
            isDisabled={isLoading}
            isLoading={isLoading}
            text={TEXT_CONSTANT.START_FREE_TRAIL}
            class="sign-up-button-new d-inline-block mb-3 text-uppercase"
          />
        </div>
      </Col>
      <Col className="p-0 vid-wrapper" xs={12} md={6}>
        <LazyImage
          errorSrc={banner}
          placeholderSrc={bannerLow}
          src={bannerWebp}
          className="w-100 img-fluid mx-2"
        />
      </Col>
    </Row>
  );
};

JoinPlan.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  onClick: PropTypes.func,
};
